import React from "react"
import { useRouter } from "../../../../hooks"

export const membershipTabs = [
  { labelKey: "membershipsTabLabel", value: "memberships" },
  { labelKey: "hourReportingRolesTabLabel", value: "hour-reporting-roles" },
  { labelKey: "hourReportingAdminsTabLabel", value: "hour-reporting-admins" },
] as const

export type MembershipTab = (typeof membershipTabs)[number]["value"]

type UseMembershipTabsOptions = {
  canViewMemberships: boolean
  canViewHourReportingRoles: boolean
  canViewHourReportingAdmins: boolean
  isLoading: boolean
}

export const useMembershipsTabs = ({
  canViewMemberships,
  canViewHourReportingRoles,
  canViewHourReportingAdmins,
  isLoading,
}: UseMembershipTabsOptions) => {
  const router = useRouter()
  const query = router.query as { tab?: string }

  const availableTabs = membershipTabs.filter((tab) => {
    switch (tab.value) {
      case "memberships":
        return canViewMemberships
      case "hour-reporting-roles":
        return canViewHourReportingRoles
      case "hour-reporting-admins":
        return canViewHourReportingAdmins
      default:
        return false
    }
  })

  const requestedTab = availableTabs.find((tab) => tab.value === query.tab)?.value
  const activeTab = requestedTab ?? availableTabs[0]?.value
  const activeTabIndex = activeTab ? availableTabs.findIndex((tab) => tab.value === activeTab) : 0

  const handleTabChange = (_: React.ChangeEvent<{}>, newValue: number) => {
    const selectedTab = availableTabs[newValue]
    if (!selectedTab) return

    const currentSearch = new URLSearchParams(router.location.search)
    currentSearch.set("tab", selectedTab.value)
    router.push({ search: currentSearch.toString() })
  }

  return {
    activeTab,
    activeTabIndex,
    availableTabs,
    handleTabChange,
    hasAvailableTabs: availableTabs.length > 0,
    isLoading,
  }
}
